/**
 * @param {unknown} value
 * @returns {number}
 */
function toFiniteNumber(value) {
    if (value === null || value === undefined || value === '') {
        return NaN;
    }
    const n = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(n) ? n : NaN;
}

/**
 * Great-circle distance in metres between two WGS84 points (spherical law of cosines).
 * Matches the legacy ForceManager map helper: degrees → nautical miles × 1.609344 km × 1000,
 * then floored to an integer metre value.
 *
 * @param {unknown} lat1 Latitude of point A in decimal degrees
 * @param {unknown} lon1 Longitude of point A in decimal degrees
 * @param {unknown} lat2 Latitude of point B in decimal degrees
 * @param {unknown} lon2 Longitude of point B in decimal degrees
 * @returns {number|null} Distance in metres, or `null` if any coordinate is not a finite number
 */
export function getDistanceInMeters(lat1, lon1, lat2, lon2) {
    const a = toFiniteNumber(lat1);
    const b = toFiniteNumber(lon1);
    const c = toFiniteNumber(lat2);
    const d = toFiniteNumber(lon2);
    if (![a, b, c, d].every(Number.isFinite)) {
        return null;
    }

    const radlat1 = (Math.PI * a) / 180;
    const radlat2 = (Math.PI * c) / 180;
    const radtheta = (Math.PI * (b - d)) / 180;
    let cosDist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    cosDist = Math.min(1, Math.max(-1, cosDist));
    let dist = Math.acos(cosDist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515 * 1.609344 * 1000;
    return Math.floor(dist);
}
